import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'i18n-js';

import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';
import Loading from '../../shared/Loading';

const Fog = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  background-color: ${colors.hubspotModalBackdrop};
`;

const SpinnerWrapper = styled.div`
  color: ${colors.lighterGray};
  font-family: ${fonts.family.workSans};
  width: 120px;
  margin: 0 auto;
  z-index: 999;
`;

const SpinnerTopLabel = styled.div`
  font-size: 1.2em;
  font-weight: 900;
  margin-top: 20px;
  text-align: center;
`;

const SpinnerBotLAbel = styled.div`
  font-size: 0.85em;
  text-align: center;
  font-weight: 800;
`;

const LoadingWrapper = ({globalLoading}) => {
  return (globalLoading ? (<Fog>
    <SpinnerWrapper>
      <Loading color={colors.lighterGray} size={8} type={'dots'}/>
      <SpinnerTopLabel>
        {I18n.t('shared.processing')}
      </SpinnerTopLabel>
      <SpinnerBotLAbel>
        {I18n.t('shared.processingMessage')}
      </SpinnerBotLAbel>
    </SpinnerWrapper>
  </Fog>) : null)
};

LoadingWrapper.propTypes = {
  globalLoading: PropTypes.bool
};

export default LoadingWrapper;
